var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjects({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 2.375C3.22944 2.375 2.875 2.72944 2.875 3.16667V5.54167C2.875 5.9789 3.22944 6.33333 3.66667 6.33333H7.625C8.06224 6.33333 8.41667 5.9789 8.41667 5.54167V3.16667C8.41667 2.72944 8.06224 2.375 7.625 2.375H3.66667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.125 3.5625H10V5.14583H17.125V3.5625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.875 13.4583C2.875 13.0211 3.22944 12.6667 3.66667 12.6667H7.625C8.06224 12.6667 8.41667 13.0211 8.41667 13.4583V15.8333C8.41667 16.2706 8.06224 16.625 7.625 16.625H3.66667C3.22944 16.625 2.875 16.2706 2.875 15.8333V13.4583Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.125 13.8542H10V15.4375H17.125V13.8542Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 7.52083C3.22944 7.52083 2.875 7.87526 2.875 8.31249V10.6875C2.875 11.1247 3.22944 11.4792 3.66667 11.4792H7.625C8.06224 11.4792 8.41667 11.1247 8.41667 10.6875V8.31249C8.41667 7.87526 8.06224 7.52083 7.625 7.52083H3.66667Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.125 8.70833H10V10.2917H17.125V8.70833Z",
    fill: "white",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.1848864f5618873ef12f4503736afc04.svg";
export { ForwardRef as ReactComponent };